import { elementExists } from '../../core/utils';

const CollectionProductGrid = function () {
  const container = document.querySelector('[data-collection-product-grid]');
  if (elementExists(container)) {
    const filtersContainer = container.querySelector(
      '[data-collection-product-grid-filters]',
    );
    const resultContainer = container.querySelector(
      '[data-collection-product-grid-results]',
    );
    const activeFiltersContainer = container.querySelector(
      '[data-collection-product-grid-active-filters]',
    );
    const baseUrl = container.dataset.url;
    let filterForm = null;
    let filterParams = '';
    let allBtns = [];
    let btnRemoveFilters = null;

    const initFunctions = function () {
      addAllButtons();
      initForm();
      initPagination();
    };

    /**
     * set the filter form and add the event listerners
     */
    const initForm = function () {
      filterForm = filtersContainer.querySelector(
        '[data-collection-product-grid-filters-form]',
      );
      filterForm.addEventListener('submit', function (evt) {
        evt.preventDefault();
        submitFilter();
      });

      filterForm.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function (evt) {
          if (evt.target.type === 'checkbox' || evt.target.type === 'radio') {
            submitFilter();
          }
        });
      });
    };

    const initPagination = function () {
      const paginationLinks = container.querySelectorAll('.page-pagination a');
      paginationLinks.forEach((link) => {
        let page = link.href.split('page=')[1];
        page = page ? page.split('&')[0] : '';
        const updatedHref = baseUrl + '?' + getFilterParams() + '&page=' + page;
        link.setAttribute('href', updatedHref);
      })
    }

    /**
     * Get the all buttons and add the event listeners
     */
    const addAllButtons = function () {
      allBtns = container.querySelectorAll('[data-filter-btn-all]');
      allBtns.forEach((btn) => {
        btn.addEventListener('click', function (evt) {
          evt.preventDefault();

          let filterGroup = evt.currentTarget.dataset.filterBtnAll;

          filterForm
            .querySelectorAll(
              `[data-filter-group="${filterGroup}"] input[type="checkbox"]`,
            )
            .forEach((input) => {
              input.checked = false;
            });

          submitFilter();
        });
      });
      btnRemoveFilters = container.querySelectorAll(
        '[data-collection-product-grid-remove-filter]',
      );
      if (elementExists(btnRemoveFilters, true)) {
        btnRemoveFilters.forEach((btn) => {
          btn.addEventListener('click', function (evt) {
            evt.preventDefault();
            let href = evt.currentTarget.getAttribute('href');
            href = href.replace(baseUrl, '').replace('?', '');
            filterParams = href;
            populateGrid();
          });
        });
      }
    };

    /**
     * Get the filter params from the form
     * @returns {string} filterParams
     */
    const getFilterParams = function () {
      let formData = new FormData(filterForm);
      let search = new URLSearchParams(formData);
      filterParams = search.toString();
      return filterParams;
    };

    /**
     * Submit the filter form
     */
    const submitFilter = function () {
      getFilterParams();
      populateGrid();
    };

    /**
     * @param {*} url
     * Populate the grid with ajax results from the provided url
     */
    const populateGrid = function (url = false) {
      if (!url) url = baseUrl + '?' + filterParams //+ '&view=ajax';

      window.location = url;

      // updateUrl();
      // fetch(url)
      //   .then((res) => {
      //     if (!res.ok) return false;
      //     return res.text();
      //   })
      //   .then((text) => {
      //     if (!text) return;

      //     let div = document.createElement('div');
      //     div.innerHTML = text;
      //     const resResultsContainer = div.querySelector(
      //       '[data-collection-product-grid-results]',
      //     );
      //     const resFiltersContainer = div.querySelector(
      //       '[data-collection-product-grid-filters]',
      //     );
      //     const resActiveFiltersContainer = div.querySelector(
      //       '[data-collection-product-grid-active-filters]',
      //     );
      //     resultContainer.innerHTML = resResultsContainer.innerHTML;
      //     filtersContainer.innerHTML = resFiltersContainer.innerHTML;
      //     activeFiltersContainer.innerHTML =
      //       resActiveFiltersContainer.innerHTML;
      //     initFunctions();
      //   });
    };

    /**
     * Update the browser url without reloading the page
     * based on the filter params
     */
    const updateUrl = function () {
      var newRelativePathQuery = window.location.pathname + '?' + filterParams;
      history.pushState(null, '', newRelativePathQuery);
    };

    // initialize
    initFunctions();
  }
};

export default CollectionProductGrid;
